/**
 * External Dependencies
 */
/*
import 'jquery';

$(() => {
  // console.log('Hello world');
});
*/
//import Isotope from 'isotope-layout';
import { Offcanvas } from 'bootstrap';
import Headroom from 'headroom.js';
import { Loader } from '@googlemaps/js-api-loader';

import TomSelect from 'tom-select';

import Swiper, { Navigation, Thumbs } from 'swiper';
Swiper.use([Navigation, Thumbs]);

import SimpleLightbox from "simplelightbox";

const rosnickaMenu = () => {
	var offcanvasElementList = [].slice.call(document.querySelectorAll('.offcanvas'))
	// eslint-disable-next-line no-unused-vars
	var offcanvasList = offcanvasElementList.map(function (offcanvasEl) {
		return new Offcanvas(offcanvasEl)
	})
}

const rosnickaSelects = () => {
	if(document.body.contains(document.querySelector('.ro_filter'))) {
		let selects = document.querySelectorAll('.ro_filter select');
		for(let i = 0; i < selects.length; i++) {
			const select = selects.item(i);
			let singleSelect = new TomSelect(select, {
				plugins: {
					remove_button:{
						title:'Odstranit',
					},
				},
				closeAfterSelect: true,
				persist: false,
				delimiter: '||',
				render: {
					no_results: function() {
						return '<div class="no-results">Toto bohužel nemáme :(</div>';
					},
				},
			});
			singleSelect.on('change', (values) => {
				const data = new FormData();
				data.append('action', 'filter_goods');
				data.append('filter_'+select.getAttribute('id'), JSON.stringify(values));
				data.append('tax_id', select.getAttribute('data-taxonomy'));
				
				// eslint-disable-next-line no-undef
				fetch( template_vars.ajaxUrl, {
					method: 'POST',
					credentials: 'same-origin',
					body: data,
				}).then( res => res.text() )
				.then( data => {
					console.log(data);
					document.querySelector('.ro_archive-list--output').innerHTML = data;
				} )
				.catch( err => console.log( err ) );
			})
		}
	}
}

const rosnickaScrollTo = () => {
	let scrollLinks 	= document.querySelectorAll('[data-scroll]');
	
	for (let i = 0; i < scrollLinks.length; i++) {
		const el = scrollLinks.item(i);

		el.addEventListener('click', (e) => {
			e.preventDefault();

			let hash = e.target.getAttribute('data-scroll');
            let target = document.querySelector(hash);
            let headerOffset = 100;
            let elementPosition = target.offsetTop;
            let offsetPosition = elementPosition - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
		});
	}
	
	var hashLink = window.location.hash;

	if(hashLink.length) {
		if(document.body.contains(document.querySelector(hashLink))){
			let headerOffset = 100;
			let elementPosition = document.querySelector(hashLink).offsetTop;
			let offsetPosition = elementPosition - headerOffset;

			window.scrollTo({
				top: offsetPosition,
				behavior: "smooth",
			});
		}
	}
}

const rosnickaSidebar = () => {
	if(document.body.contains(document.querySelector('.ro_archive-sidebar nav'))) {
		let mainItems = document.querySelectorAll('.ro_archive-sidebar nav a[data-bs-toggle]');
		for(let i = 0; i < mainItems.length; i++) {
			const item = mainItems.item(i);
			item.addEventListener('click', (e) => {
				e.preventDefault();
				item.classList.toggle('sub-active');
			});
		}
	}
}

const rosnickaStickyHeader = () => {
	const header = document.querySelector('.ro_header');
	const headroom = new Headroom(header);
	headroom.init();
}

const rosnickaCarousel = () => {
	if(document.body.contains(document.querySelector('.ro_carousel .swiper-container'))){
		// eslint-disable-next-line no-unused-vars
		const peReviewAltSwiper = new Swiper('.ro_carousel .swiper-container', {
			speed: 400,
			slidesPerView: 1,
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				992: {
					slidesPerView: 3,
				},
				1280: {
					slidesPerView: 4,
					spaceBetween: 52,
				},
			},
			navigation: {
				nextEl: '.ro_carousel-arrow--next',
				prevEl: '.ro_carousel-arrow--prev',
			},
		});
	}
}

const rosnickaMap = (iconPath) => {
	if(document.body.contains(document.querySelector('.ro_map-map'))){

		const loader = new Loader({
			apiKey: 'AIzaSyCMiSmP0BksgE7ARvBcI-kSiN92EcrnNVw&#038',
		});

		const mapOptions = {
			center: {
				lat: 49.09510776666193, 
				lng: 15.889908626896336,
			},
			zoom: 15,
			scrollwheel: false,
			draggable: true,
			disableDefaultUI: true,
		};

		loader
			.load()
			.then((google) => {
				let map = new google.maps.Map(document.querySelector('.ro_map-map'), mapOptions);
				let marker = new google.maps.Marker({
					position: mapOptions.center,
					map: map,
					icon: iconPath,
					url: 'https://g.page/VinotekaRosnicka?share',
				});

				google.maps.event.addListener(marker, 'click', function() {
					//window.location.href = marker.url;
					window.open(this.url, '_blank').focus();
				});

			})
			.catch(e => {
				console.warn('Vyskytl se problém s inicializací mapy.');
				console.warn(e);
			});
	}
}

const rosnickaGallery = () => {
	if(document.body.contains(document.querySelector('.ro_gallery'))){
		new SimpleLightbox('.ro_gallery a', { /* options */ });
	}
}

const initRosnicka = () => {
	rosnickaMenu();
	rosnickaStickyHeader();
	rosnickaCarousel();
	rosnickaSelects();
	//rosnickaFilter(); 	
	rosnickaGallery();
	rosnickaSidebar();
	// eslint-disable-next-line no-undef
	rosnickaMap(template_vars.iconPath);
}

const rosnickaCookies = () => {
	// eslint-disable-next-line no-undef    
	var cc = initCookieConsent();

        cc.run({
            current_lang: 'cs',
            autoclear_cookies: true,
            remove_cookie_tables: true,

            onAccept: function () {
				if(cc.allowedCategory('analytics')){
					// eslint-disable-next-line no-undef
					gtag('consent', 'update', {
						'analytics_storage': 'granted',
					});
				}
				
				if(cc.allowedCategory('ads')){
					// eslint-disable-next-line no-undef
					gtag('consent', 'update', {
						'ad_storage': 'granted',
					});
				}
			},

			onChange: function (cookie, changed_preferences) {   
				var len = changed_preferences.length;
				for (var i = 0; i < len; i++) {
					let name = changed_preferences[i];
					if (cookie.level.includes(name)) {
						if (name == 'analytics') {
							// eslint-disable-next-line no-undef
							gtag('consent', 'update', {
								'analytics_storage': 'granted',
							});
						}
						if (name == 'ads') {
							// eslint-disable-next-line no-undef
							gtag('consent', 'update', {
								'ad_storage': 'granted',
							});
						}
					} else {
						if (name == 'analytics') {
							// eslint-disable-next-line no-undef
							gtag('consent', 'update', {
								'analytics_storage': 'denied',
							});
						}
						if (name == 'ads') {
							// eslint-disable-next-line no-undef
							gtag('consent', 'update', {
								'ad_storage': 'denied',
							});
						}
					}
				}
			},

            languages: {
                'cs': {
                    consent_modal: {
                        title: 'Používáme cookies!',
                        description: 'Tato webová stránka používá nezbytné soubory cookies k zajištění správného fungování. A dále další soubory cookies, které slouží k tomu, abychom pro vás mohli webové stránky vylepšovat a optimalizovat. Tato volba bude nastavena až po souhlasu.',
						primary_btn: {
                            text: 'Přijmout vše',
                            role: 'accept_all',
                        },
                        secondary_btn: {
							text: 'Nastavení',
						},
                    },
                    settings_modal: {
                        title: 'Předvolby souborů cookies',
                        save_settings_btn: 'Uložit nastavení',
                        accept_all_btn: 'Přijmout vše',
                        reject_all_btn: false,
                        close_btn_label: 'Zavřít',
                        blocks: [
                            {
                                title: 'Použití cookies',
                                description: 'Soubory cookies používáme k zajištění základních funkcí webu a ke zlepšení vašeho online zážitku. Pro každou kategorii si můžete vybrat, zda se chcete přihlásit/odhlásit, kdykoliv budete chtít. Veškeré podrobnosti týkající se souborů cookies a dalších citlivých údajů naleznete v úplném znění zásad ochrany osobních údajů.',
                            }, {
                                title: 'Nezbytné cookies',
                                description: 'Tyto soubory cookies jsou nezbytné pro správné fungování našich webových stránek. Bez těchto cookies by web nefungoval správně.',
                                toggle: {
                                    value: 'necessary',
                                    enabled: true,
                                    readonly: true,
                                },
                            },
							{
                                title: 'Soubory cookies pro výkon a analytiku',
                                description: 'Tyto soubory cookies umožňují webu zapamatovat si nastavení, které jste provedli v minulosti. Také shromažďují informace o tom, jak web používáte, které stránky jste navštívili a na které odkazy jste klikli. Všechna data jsou anonymní a nelze je použít k vaší identifikaci.',
                                toggle: {
                                    value: 'analytics',
                                    enabled: false,
                                    readonly: false,
                                },
                            },
							{
                                title: 'Soubory cookies pro reklamu a cílení',
                                description: 'Marketingové cookies slouží k pochopení chování uživatelů na našich webových stránkách. Tyto cookies se také používají k zobrazování reklam, které jsou relevantnější pro vaše zájmy. Tyto informace můžeme sdílet s reklamními platformami, které mohou také ukládat informace o chování uživatele získané při procházení. To nám umožňuje vytvořit konkrétní profil a zobrazovat reklamy odpovídající vašim zájmům.',
                                toggle: {
                                    value: 'ads',
                                    enabled: false,
                                    readonly: false,
                                },
                            },
							{
                                title: 'Více informací',
                                description: 'Máte-li jakékoli dotazy ohledně našich zásad týkajících se souborů cookies nebo dalšího nastavení, kontaktujte nás.',
                            },
                        ],
                    },
                },
            },
        });
}

document.addEventListener('DOMContentLoaded', () => {
	initRosnicka();
});

window.addEventListener('load', () => {
	rosnickaScrollTo();
	rosnickaCookies();
});